import { render, staticRenderFns } from "./HistorialAtencionModal.vue?vue&type=template&id=929c4a62"
import script from "./HistorialAtencionModal.vue?vue&type=script&lang=js"
export * from "./HistorialAtencionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports